export interface AuthState {
  isLoggedIn: boolean;
  loggedInUser: User | null;
}

export interface User {
  name: string;
  phoneNumber: string;
}

export enum AuthType {
  Email = "email",
  PhoneNumber = "tel",
}

export enum MailCheckType {
  Registration = 0,
  ForgotPasword = 1,
  ChangeEmail = 2,
}
